export default "__VITE_ASSET__2sfbVGty__"